import AddressFormatter from "@shopify/address"
import { Address } from "@shopify/address-consts"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import CompanyDescription from "../companyDescription/CompanyDescription"
import CompanyDescriptionService from "../companyDescription/CompanyDescriptionService"
import { ContactAddressDto } from "./models"

const unsupportedCountryCodes = ["USA", "PR"]

const unsupportedCountryCodeToNameMapping = {
    "USA": "United States",
    "PR": "Puerto Rico",
}

export default class ContactAddressFormatter {
    private addressFormatter: AddressFormatter
    private readonly address: Address

    constructor(contactAddress: ContactAddressDto) {
        this.addressFormatter = new AddressFormatter(AppContext.getLocale().getLanguageWithoutRegionCode())
        this.address = {
            address1: contactAddress.street,
            address2: contactAddress.street2,
            city: contactAddress.city,
            province: contactAddress.stateCode,
            zip: contactAddress.postalCode,
            country: contactAddress.countryCode
        }
    }

    async getOrderedFields() {
        await this.setValidCountryCode()
        return await this.addressFormatter.getOrderedFields(this.address.country)
    }

    async getFormattedAddressValues(): Promise<string[]> {
        if (this.isValidCountryCode(this.address.country)) {
            const formattedAddress = await this.addressFormatter.format(this.address)
            return formattedAddress.filter(value => value != "")
        }

        const countyName = unsupportedCountryCodeToNameMapping[this.address.country]
        this.address.country = "US"

        const formattedAddress = await this.addressFormatter.format(this.address)
        formattedAddress[5] = countyName
        return formattedAddress.filter(value => value != "")
    }

    private async getDefaultCountryCode(): Promise<string> {
        const res = await CompanyDescriptionService.get()
        if (!(res instanceof CompanyDescription)) {
            return "US"
        }

        if (this.isValidCountryCode(res.getDefaultCountryCode())){
            return res.getDefaultCountryCode()
        }

        return "US"
    }

    private isValidCountryCode(country: string | null): boolean {
        return !!country && !unsupportedCountryCodes.find(e => e === country)
    }

    private async setValidCountryCode() {
        let countryCode = this.address.country
        if (!this.isValidCountryCode(countryCode)) {
            countryCode = await this.getDefaultCountryCode()
        }
        this.address.country = countryCode
    }
}



// WEBPACK FOOTER //
// ./src/state/contact/AddressFormatter.ts